import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrgLeaveComponent } from './org-leave.component';
import { OrgLeavesDetailsComponent } from './components/org-leaves-details/org-leaves-details.component';
import { OrgLeavesCreateComponent } from './components/org-leaves-create/org-leaves-create.component';

const routes: Routes = [
  {
    path: '', component:OrgLeaveComponent,children:[
       {
         path:'',component: OrgLeavesDetailsComponent
       },
       {
        path:'details',component: OrgLeavesDetailsComponent
       },
       {
         path: ':id',component:OrgLeavesCreateComponent
       } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrgLeaveRoutingModule { }
